export interface Nation {
  code: string; // ISO 3166-1 alpha-3
  name: string;
  flagImage: string;
}

export const NATIONS: Nation[] = [
  // Special roles
  { code: 'EUR', name: 'EU', flagImage: '/flags/eu.png' },
  { code: 'SIM', name: 'EXCON', flagImage: '/flags/excon.png' },

  // NATO & Partners (alphabetically)
  { code: 'ALB', name: 'Albania', flagImage: '/flags/al.png' },
  { code: 'AUT', name: 'Austria', flagImage: '/flags/at.png' },
  { code: 'BEL', name: 'Belgium', flagImage: '/flags/be.png' },
  { code: 'BGR', name: 'Bulgaria', flagImage: '/flags/bg.png' },
  { code: 'CAN', name: 'Canada', flagImage: '/flags/ca.png' },
  { code: 'HRV', name: 'Croatia', flagImage: '/flags/hr.png' },
  { code: 'CYP', name: 'Cyprus', flagImage: '/flags/cy.png' },
  { code: 'CZE', name: 'Czech Republic', flagImage: '/flags/cz.png' },
  { code: 'DNK', name: 'Denmark', flagImage: '/flags/dk.png' },
  { code: 'EST', name: 'Estonia', flagImage: '/flags/ee.png' },
  { code: 'FIN', name: 'Finland', flagImage: '/flags/fi.png' },
  { code: 'FRA', name: 'France', flagImage: '/flags/fr.png' },
  { code: 'DEU', name: 'Germany', flagImage: '/flags/de.png' },
  { code: 'GRC', name: 'Greece', flagImage: '/flags/gr.png' },
  { code: 'HUN', name: 'Hungary', flagImage: '/flags/hu.png' },
  { code: 'ISL', name: 'Iceland', flagImage: '/flags/is.png' },
  { code: 'IRL', name: 'Ireland', flagImage: '/flags/ie.png' },
  { code: 'ITA', name: 'Italy', flagImage: '/flags/it.png' },
  { code: 'LVA', name: 'Latvia', flagImage: '/flags/lv.png' },
  { code: 'LIE', name: 'Liechtenstein', flagImage: '/flags/li.png' },
  { code: 'LTU', name: 'Lithuania', flagImage: '/flags/lt.png' },
  { code: 'LUX', name: 'Luxembourg', flagImage: '/flags/lu.png' },
  { code: 'MLT', name: 'Malta', flagImage: '/flags/mt.png' },
  { code: 'MDA', name: 'Moldova', flagImage: '/flags/md.png' },
  { code: 'MNE', name: 'Montenegro', flagImage: '/flags/me.png' },
  { code: 'NLD', name: 'Netherlands', flagImage: '/flags/nl.png' },
  { code: 'MKD', name: 'North Macedonia', flagImage: '/flags/mk.png' },
  { code: 'NOR', name: 'Norway', flagImage: '/flags/no.png' },
  { code: 'POL', name: 'Poland', flagImage: '/flags/pl.png' },
  { code: 'PRT', name: 'Portugal', flagImage: '/flags/pt.png' },
  { code: 'ROU', name: 'Romania', flagImage: '/flags/ro.png' },
  { code: 'SVK', name: 'Slovakia', flagImage: '/flags/sk.png' },
  { code: 'SVN', name: 'Slovenia', flagImage: '/flags/si.png' },
  { code: 'ESP', name: 'Spain', flagImage: '/flags/es.png' },
  { code: 'SWE', name: 'Sweden', flagImage: '/flags/se.png' },
  { code: 'CHE', name: 'Switzerland', flagImage: '/flags/ch.png' },
  { code: 'TUR', name: 'Turkey', flagImage: '/flags/tr.png' },
  { code: 'UKR', name: 'Ukraine', flagImage: '/flags/ua.png' },
  { code: 'GBR', name: 'United Kingdom', flagImage: '/flags/gb.png' },
  { code: 'USA', name: 'United States', flagImage: '/flags/us.png' },
];

export function getNationByCode(code: string): Nation | undefined {
  return NATIONS.find(n => n.code === code);
}

export function getNationByName(name: string): Nation | undefined {
  return NATIONS.find(n => n.name === name);
}
